<template>
    <div id="app">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>

        <!-- 遮罩层 -->
        <div class="maskLayer" v-if="maskLayer">
            <!-- 添加账号弹出框 -->
            <div class="bgAddAccountModel" v-if="allModelShow == 1">
                <div class="top-style">
                    <div class="top-style-left"></div>
                    <div class="top-style-right"></div>
                </div>
                <div class="modelTitle">添加账号</div>
                <!-- form表单 -->

                <el-form ref="formAddAccount" :model="formAddAccount" label-width="80px" class="addAccountForm">
                    <el-form-item label="登录账号：" prop="loginAccount">
                        <i class="stars1">*</i>
                        <el-input v-model="formAddAccount.loginAccount"></el-input>
                        <div class="loginAccountHint">{{accountError}}</div>
                    </el-form-item>
                    <el-form-item label="后台权限：" prop="type">
                        <div>
                            <span>企业趋势</span>
                            <span>企业统计</span>
                        </div>
                        <el-checkbox-group v-model="formAddAccount.type">

                            <el-checkbox label="企业订单" name="type"></el-checkbox>
                            <el-checkbox label="企业管理" name="type"></el-checkbox>
                            <el-checkbox label="企业观察" name="type"></el-checkbox>
                            <el-checkbox label="企业网站" name="type"></el-checkbox>
                            <el-checkbox label="系统设置" name="type"></el-checkbox>
                            <el-checkbox label="后台设置" name="type"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="初始密码：" prop="initialPass">
                        <i class="stars1">*</i>
                        <el-input type="password" v-model="formAddAccount.initialPass"></el-input>
                        <div class="loginAccountHint">{{InitialPassError}}</div>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="success" @click="addAccountOnSubmit">确定</el-button>
                        <el-button type="reset" @click="addAccountCancel(formAddAccount)">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>

			<!-- 修改账号弹出框 -->
			<div class="bgAddAccountModel" v-else-if="allModelShow == 2">
				<div class="top-style">
					<div class="top-style-left"></div>
					<div class="top-style-right"></div>
				</div>
				<div class="modelTitle">修改账号</div>
				<!-- form表单 -->
				<el-form ref="formEditAccount" :model="formEditAccount" label-width="80px" class="addAccountForm">
					<el-form-item label="登录账号：">
						<span>{{personageAccData.account}}</span>
					</el-form-item>
					<el-form-item label="后台权限：">
						<div>
							<span>企业趋势</span>
							<span>企业统计</span>
						</div>
						<el-checkbox-group v-model="formEditAccount.type">
							<el-checkbox label="企业订单" name="type"></el-checkbox>
							<el-checkbox label="企业管理" name="type"></el-checkbox>
							<el-checkbox label="企业观察" name="type"></el-checkbox>
							<el-checkbox label="企业网站" name="type"></el-checkbox>
							<el-checkbox label="系统设置" name="type"></el-checkbox>
							<el-checkbox label="后台设置" name="type"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="重置密码：" prop="initialPass">
						<el-input v-model="formEditAccount.initialPass"></el-input>
						<div class="loginAccountHint">{{editInitialPassError}}</div>
					</el-form-item>

                    <el-form-item>
                        <el-button type="success" @click="editAccountOnSubmit">确定</el-button>
                        <el-button @click="editAccountCancel">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 删除账号弹出框 -->
            <div class="bgDelAccountModel" v-else-if="allModelShow == 3">
                <div class="DelAcc-title">
                    <div class="title-style">
                    </div>
                    <p>提示!</p>
                </div>
                <div class="DelAcc-content">
                    <p>是否删除登录账号
                        <span> &quot;{{deleteAccount}}&quot; </span>?</p>

                    <div class="DelAcc-btn">
                        <el-button type="success" @click="DelAccountOnSubmit">确定</el-button>
                        <el-button @click="DelAccountCancel">取消</el-button>
                    </div>
                </div>
            </div>


				<!-- 管理操作弹出框 -->
			<div class="bgAddAccountModel" v-else-if="allModelShow == 4">
				<div class="top-style">
					<div class="top-style-left"></div>
					<div class="top-style-right"></div>
				</div>
				<div class="modelTitle">管理操作</div>
				<!-- form表单 -->
				<el-form ref="formManageOperation" :model="formManageOperation" label-width="80px" class="ManageOperationForm">
					<el-form-item label="注册账号：">
						<span>{{cpMangeDatas.email}}</span>
					</el-form-item>
					<el-form-item label="企业名称：">
						<span>{{cpMangeDatas.company}}</span>
					</el-form-item>
					<el-form-item label="体验坐席数：">
						<el-input-number v-model="formManageOperation.freeWaiterPara" :min="1" ></el-input-number>
					</el-form-item>
					<el-form-item label="留言消息：">
						<!-- 遮板 -->
						<div class="similarityBefore"></div>
						<el-radio-group v-model="formManageOperation.leaveMsgPara"  @change="leaveMsgParaChange">
							<el-radio :disabled="cpMgDisabled" class="radio" label="1">有限制</el-radio>
							<el-input :disabled="cpMgDisabled" @change="leaveMgChange" v-model="formManageOperation.leaveMsgParaInput"></el-input>
							<el-radio :disabled="cpMgDisabled" class="radio" label="2">无限制</el-radio>
						</el-radio-group>
						
					</el-form-item>	

					<el-form-item label="机器人消息：">
						<!-- 遮板 -->
						<div class="similarityBefore"></div>
						<el-radio-group v-model="formManageOperation.rbMsgPara" @change="rbMsgParaChange">
							<el-radio :disabled="cpMgDisabled" class="radio" label="1">有限制</el-radio>
							<el-input :disabled="cpMgDisabled" @change="rbChange" v-model="formManageOperation.rbMsgParaInput"></el-input>
							<el-radio :disabled="cpMgDisabled" class="radio" label="2">无限制</el-radio>
						</el-radio-group>
						
					</el-form-item>	

                    <el-form-item>
                        <el-button type="success" @click="manageOperationOnSubmit">确定</el-button>
                        <el-button @click="manageOperationCancel">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 修改密码弹出框 -->
            <div class="modifyPassword" v-else-if="allModelShow == 5">
                <div class="top-style">
                    <div class="top-style-left"></div>
                    <div class="top-style-right"></div>
                </div>
                <div class="modelTitle">修改密码</div>
                <!-- form表单 -->
                <el-form ref="formModifyPassword" :model="formModifyPassword" label-width="80px" class="addModifyForm">
                    <el-form-item label="原密码：">
                        <span class="redStar">*</span>
                        <el-input type="password" v-model="formModifyPassword.originPassword"></el-input>
                        <div class="modifyPasswordHint" v-if="modifyPasswordTriggeringCon.originPassword.empty">
                            原密码不能为空
                        </div>
                        <div class="modifyPasswordHint" v-else-if="modifyPasswordTriggeringCon.originPassword.invalid">
                            原密码错误
                        </div>
                    </el-form-item>
                    <el-form-item label="新密码：">
                        <span class="redStar">*</span>
                        <el-input type="password" v-model="formModifyPassword.newPassword"></el-input>
                        <div class="modifyPasswordHint" v-if="modifyPasswordTriggeringCon.newPassword.empty">请输入新密码
                        </div>
                        <div class="modifyPasswordHint" v-else-if="modifyPasswordTriggeringCon.newPassword.limit">
                            密码不能少于6个字符
                        </div>
                    </el-form-item>
                    <el-form-item label="确认新密码：">
                        <span class="redStar">*</span>
                        <el-input type="password" v-model="formModifyPassword.repeatPassword"></el-input>
                        <div class="modifyPasswordHint" v-if="modifyPasswordTriggeringCon.repeatPassword.empty">
                            请再次输入新密码
                        </div>
                        <div class="modifyPasswordHint"
                             v-else-if="modifyPasswordTriggeringCon.repeatPassword.identical">与第一次输入的新密码不一致
                        </div>
                    </el-form-item>
                    <el-form-item label="M令牌：" class="m-token-setting">
                        <span>{{mTokenStatus.enabled ? '已开启' : '未开启'}}</span>
                        <el-button
                            size="small"
                            :type="mTokenStatus.enabled ? 'danger' : 'success'"
                            :loading="mTokenLoading"
                            @click="toggleMToken"
                        >{{mTokenStatus.enabled ? '关闭' : '开启'}}</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="comfirmPassword">确定</el-button>
                        <el-button type="reset" @click="addModifyPasswordCancel()">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <m-token-dialog ref="mTokenRef" @verified="mTokenVerified"></m-token-dialog>
    </div>
</template>

<script>
    import bus from "./common/commonVue.js";
    import "./statics/css/app.scss";
    import qs from "qs";
    import MTokenDialog from './components/mToken/mTokenDialog.vue';

export default {
	name: 'app',
	components: { MTokenDialog },
	data() {
		return {
			// 控制遮罩层的显示
			maskLayer: false,
			//控制弹出框的显示(所有),
			allModelShow: 0,
			//修改密码弹出框的form数据
			formModifyPassword:{
			  	originPassword:"",
				newPassword:"",
				repeatPassword:"",
			},
			//添加账号弹出框的form数据
			formAddAccount: {
				loginAccount: '',
				initialPass: "",
				type: []
			},
			//编辑账号弹出框的form数据
			formEditAccount: {
				initialPass: '',
				type: []
			},
			//管理操作弹出框的form数据
			formManageOperation: {
				//管理操作--体验坐席数(计数器值)
				freeWaiterPara: 1,
				//留言消息 value
				leaveMsgPara: '1',
				//机器人消息 value
				rbMsgPara: '1',
				//留言消息 input
				leaveMsgParaInput: '',
				//机器人消息 input
				rbMsgParaInput: ''
			},
			//控制管理操作input的disable
			cpMgDisabled:false,
			//显示报错信息--添加账号
			accountError: "",
			//显示报错信息--修改账号
			editInitialPassError:"",
			InitialPassError: "",
			//表单提交条件--修改密码
			modifyPasswordTriggeringCon:{
			    originPassword:{
			        empty:false,
					invalid:false,
				},
				newPassword:{
			        empty:false,
					limit:false,
				},
				repeatPassword:{
			        empty:false,
                    identical:false,
				},
			},
			//表单提交条件--添加账号
			AddAccTriggeringCon:{
				accountVer:false,
				initialPassVer:false
			},
			//删除数据id
			deleteDataId:"",
			//删除数据的名称
			deleteAccount:"",
			//后台设置列表数据信息
			bgListData:[],
			//个人数据信息
			personageAccData:{
				privileges:[]
			},
			//企业管理数据信息
			cpMangeDatas:[],
			// 点击对象的索引
			index:0,

			//登录的用户信息
			userLoginInfo:{},
			afterModifyData:{},
			mTokenStatus: { enabled: false, bound: false },
			mTokenLoading: false
		}
	},
	mounted() {
		// const that = this;
		//添加账号数据传输
		bus.$on("openAddAccountModel", (usersListData,usersListData1) => {
            this.maskLayer = true;
			this.allModelShow = 1;
			this.bgListData = usersListData;
			this.bgListData1 = usersListData1;
		})
		//修改账号数据传输
		bus.$on("openEditAccountModel", (perData,index) => {
			this.index = index;
			this.maskLayer = true;
			this.allModelShow = 2;
			this.personageAccData = perData;
			//console.log("个人数据",this.personageAccData)
			for(var i = 0; i < this.personageAccData.privileges.length;i++) {
				var pgs = this.personageAccData.privileges[i];
				if(pgs == "company_trend") {
					this.personageAccData.privileges[i] = "企业趋势"
				}else if(pgs == "company_stats") {
					this.personageAccData.privileges[i] = "企业统计"
				}else if(pgs == "company_orders") {
					this.personageAccData.privileges[i] = "企业订单"
				}else if(pgs == "company_manage") {
					this.personageAccData.privileges[i] = "企业管理"
				}else if(pgs == "company_observe") {
					this.personageAccData.privileges[i] = "企业观察"
				}else if(pgs == "company_website") {
					this.personageAccData.privileges[i] = "企业网站"
				}else if(pgs == "system_manage") {
					this.personageAccData.privileges[i] = "系统设置"
				}else if(pgs == "backoffice_manage") {
					this.personageAccData.privileges[i] = "后台设置"
				}
			}

			this.formEditAccount.type = this.personageAccData.privileges;
		}),
		//删除账号数据传输
		bus.$on("openDelAccountModel", (id,account) => {
			this.maskLayer = true;
			this.allModelShow = 3;
			this.deleteDataId = id;
			this.deleteAccount = account;
		})
		//管理操作数据传输
		bus.$on("openManageOperationModel", (companyListDatas,index) => {
			this.index = index;
			this.maskLayer = true;
			this.allModelShow = 4;
			this.cpMangeDatas = companyListDatas;
			this.formManageOperation.freeWaiterPara = companyListDatas.free_waiter_num;
			this.formManageOperation.leaveMsgParaInput = companyListDatas.leave_msg_num;
			this.formManageOperation.rbMsgParaInput = companyListDatas.rb_msg_num;
			this.cpMgDisabled = false;
			//companyListDatas.charge_seats_ing = 1;
			if(companyListDatas.charge_seats_ing != 0) {
					this.formManageOperation.leaveMsgPara = "2";
					this.formManageOperation.rbMsgPara = "2";
					this.cpMgDisabled = true;
			}
			if(this.formManageOperation.leaveMsgParaInput == "无限制") {
					//console.log("留言无限制")
					//console.log(this.formManageOperation.leaveMsgParaInput)
					this.formManageOperation.leaveMsgPara = "2";
					this.formManageOperation.leaveMsgParaInput = ""
			}else {
					this.formManageOperation.leaveMsgPara = "1";

			this.formManageOperation.leaveMsgParaInput = companyListDatas.leave_msg_num;

			}
			if(this.formManageOperation.rbMsgParaInput == "无限制") {
					//console.log("机器人无限制")
					//console.log(this.formManageOperation.rbMsgParaInput)
					this.formManageOperation.rbMsgPara = "2";

					this.formManageOperation.rbMsgParaInput = ""
			}else {
					this.formManageOperation.rbMsgPara = "1";
					this.formManageOperation.rbMsgParaInput = companyListDatas.rb_msg_num;

			}

		})
		//获取登录用户信息
		bus.$on("userinfo",(userLoginInfo) => {
			this.userLoginInfo = userLoginInfo
			//console.log("出发了2",this.userLoginInfo)
		})
		bus.$on("openAddModifyPassword",()=>{
            this.maskLayer = true;
            this.allModelShow = 5;
			this.loadMTokenStatus();
		});

	},
	created() {
	},
	methods: {
		loadMTokenStatus() {
			this.$ajax.post('/api/m_token_status').then(res => {
				if (res.data && res.data.data) {
					this.mTokenStatus = res.data.data;
				}
			});
		},
		toggleMToken() {
			if (this.mTokenLoading) return;

			if (this.mTokenStatus.enabled && !this.mTokenStatus.bound) {
				this.mTokenLoading = true;
				this.$ajax.post('/api/disable_m_token', { token: '' }).then(res => {
					if (res.data && res.data.error) {
						this.$message.error('M令牌关闭失败');
					} else {
						this.$message.success('M令牌已关闭');
						this.loadMTokenStatus();
					}
				}).then(() => { this.mTokenLoading = false; });
				return;
			}

			this.$refs.mTokenRef.show({
				mode: this.mTokenStatus.enabled ? 'disable' : 'enable',
				account: this.userLoginInfo.account || ''
			});
		},
		mTokenVerified(payload) {
			const message = payload.mode === 'disable' ? 'M令牌已关闭' : 'M令牌开启成功';
			this.$message.success(message);
			this.loadMTokenStatus();
		},
		//确定--添加账号
		addAccountOnSubmit() {
			for(var i = 0;i < this.bgListData1.length;i++) {
				const test = this.bgListData1[i].account;
                // 添加账号--登录账号验证
                if (this.formAddAccount.loginAccount == "") {
						this.accountError = "登录帐号不能为空";
						setTimeout( () => {
						this.accountError = ""
						},1500)
						break;
					} else if (!/^[A-Za-z0-9]+$/.test(this.formAddAccount.loginAccount)) {
						this.accountError = "登录帐号只能为字母或数字";
						setTimeout( () => {
						this.accountError = ""
						},1500)
						break;
					} else if (this.formAddAccount.loginAccount == test) {
						this.AddAccTriggeringCon.accountVer = false;
						this.accountError = "当前登录帐号已存在";
						setTimeout( () => {
						this.accountError = ""
						},1500)
						break;
					} else {
						this.AddAccTriggeringCon.accountVer = true;
						this.accountError = ""
				}
			}

                // 添加账号--初始密码验证
                if (this.formAddAccount.initialPass == "") {
                    this.InitialPassError = "初始密码不能为空"
                    setTimeout(() => {
                        this.InitialPassError = ""
                    }, 1500)
                } else if (!/^[0-9A-Za-z]{6,}$/.test(this.formAddAccount.initialPass)) {
                    this.InitialPassError = "密码不能少于6个字符"
                    setTimeout(() => {
                        this.InitialPassError = ""
                    }, 1500)
                } else {
                    this.AddAccTriggeringCon.initialPassVer = true;
                    this.InitialPassError = ""
                }

                //提交成立时触发
            if (this.AddAccTriggeringCon.initialPassVer && this.AddAccTriggeringCon.accountVer) {
                // console.log(this.formAddAccount.type);
                this.formAddAccount.type.push("company_trend");
                this.formAddAccount.type.push("company_stats");
                this.returnEng(this.formAddAccount.type);

				this.$ajax.post(
					"/api/add_user",
					qs.stringify({
						account:this.formAddAccount.loginAccount,
						privileges:this.formAddAccount.type,
						password:this.formAddAccount.initialPass
					},
					{arrayFormat:"brackets"})
				).then(res => {
//					console.log(res);
					this.maskLayer = false;
					this.allModelShow = 0;
					this.$refs.formAddAccount.resetFields();

                    bus.$emit("addaccountcallback")
//                    bus.$emit("applybgaddlistdata",res.data.data,this.index)
					//bus.$emit("applybgeditlistdata");
				})
			}
			this.AddAccTriggeringCon.initialPassVer = false;
			this.AddAccTriggeringCon.accountVer = false;
		},
		//修改密码
		addModifyPassword(){
            this.$refs.formModifyPassword.resetFields();
            this.maskLayer = false;
            this.allModelShow = 0;
            this.formModifyPassword.originPassword = "";
            this.formModifyPassword.newPassword = "";
            this.formModifyPassword.repeatPassword = "";
		},
		//关闭添加账号弹出框
		addAccountCancel(formAddAccount) {
			this.$refs.formAddAccount.resetFields();
			this.accountError = "";
			this.InitialPassError = "";
			this.AddAccTriggeringCon.initialPassVer = false;
			this.AddAccTriggeringCon.accountVer = false;
			this.maskLayer = false;
			this.allModelShow = 0;
		},
		//确定--修改账号
		editAccountOnSubmit() {
			//console.log(this.personageAccData);
			if(!/^[0-9A-Za-z]{6,}$/.test(this.formEditAccount.initialPass) && this.formEditAccount.initialPass != ""){
				this.editInitialPassError = "密码不能少于6个字符"
			}else {
				this.editInitialPassError = "";
				this.returnEng(this.formEditAccount.type);
				// console.log(this.personageAccData.id)
				// console.log(this.formEditAccount.type)
				// console.log(this.formEditAccount.initialPass)
				this.$ajax.post(
					"/api/edit_user",
					qs.stringify({
						id:this.personageAccData.id,
						privileges:this.formEditAccount.type,
						password:this.formEditAccount.initialPass
					},
					{arrayFormat:"brackets"})
				).then(res => {
					//console.log("修改的",res);
					this.maskLayer = false;
					this.allModelShow = 0;
					// this.afterModifyData = res.data.data;
					bus.$emit("applybgeditlistdata");

			this.formEditAccount.initialPass = "";
					//用户在线的话退出登录
					if(res.data.data.id == this.userLoginInfo.id) {
						this.$ajax.get(
					"/api/sign_out/"
						).then(res => {})
							this.$router.push({path:"/loginLs",name:"登录"})
					}
				})
			}
			//this.$refs.formEditAccount.resetFields();
		},
		//关闭修改账号弹出框
		editAccountCancel() {
			this.maskLayer = false;
			this.allModelShow = 0;

			// this.$refs.formEditAccount.resetFields();
			this.editInitialPassError = "";
			this.formEditAccount.initialPass = "";
			bus.$emit("applybgeditlistdata");
		},
		//确定--删除账号
		DelAccountOnSubmit() {
			// console.log(this.deleteDataId);
			this.$ajax.post(
					"/api/delete_user",
					qs.stringify({
						id:this.deleteDataId,
					})
				).then(res => {
					//App.vueconsole.log("删除账号Id",this.deleteDataId);
					this.maskLayer = false;
					this.allModelShow = 0;
					//this.$router.go(0);
					bus.$emit("resetapplydata")

					//用户在线的话退出登录
					if(this.deleteDataId == this.userLoginInfo.id) {
						this.$router.push({path:"/loginLs",name:"登录"})
					}
			})
		},
		//关闭删除账号弹出框
		DelAccountCancel() {
			this.maskLayer = false;
			this.allModelShow = 0;
		},
		//确定--管理操作
		manageOperationOnSubmit() {
			//console.log(this.cpMangeDatas);
			this.maskLayer = false;
			this.allModelShow = 0;

                // console.log(this.cpMangeDatas.server_uid);
                // console.log(this.cpMangeDatas.prefix);
                // console.log(this.formManageOperation.freeWaiterPara);
                // console.log(this.cpMangeDatas.charge_seats_ing);

			// console.log(this.formManageOperation.leaveMsgParaInput);
			// console.log(this.formManageOperation.rbMsgParaInput);
			
			
			const ManageParams = {
				server_uid: this.cpMangeDatas.server_uid,
				prefix: this.cpMangeDatas.prefix,
				free_waiter_num: this.formManageOperation.freeWaiterPara,
				free_leave_msg_num: this.formManageOperation.leaveMsgParaInput,
				free_rb_msg_num: this.formManageOperation.rbMsgParaInput
			}

			// 判断有效坐席数是否为0，否则不需要传入留言和机器人消息
			if(this.cpMangeDatas.charge_seats_ing != 0) {
				// console.log("我变了？？");
				delete ManageParams.free_leave_msg_num;
				delete ManageParams.free_rb_msg_num;
			}



			//---------------------------------------------------------------


			//判断如果选择了无限制，则更改input框为空，页面显示为无限制
			if(this.formManageOperation.leaveMsgPara == "2") {
				ManageParams.free_leave_msg_num = "infinite";
			}
			if(this.formManageOperation.rbMsgPara == "2") {
				ManageParams.free_rb_msg_num = "infinite";
			}


			//console.log(ManageParams.free_leave_msg_num)
			//console.log("radioValue",this.formManageOperation.leaveMsgPara)


			//---------------------------------------------------------------

			console.log("ManageParams",ManageParams);
			this.$ajax.post(
				"/api/set_seat_privilege",
				qs.stringify(ManageParams)
			).then(res => {
				console.log("set_seat_privilege",res);
				this.formManageOperation.leaveMsgParaInput = res.data.data.free_leave_msg_num;
				this.formManageOperation.rbMsgParaInput = res.data.data.free_rb_msg_num;
				bus.$emit("applycpmglistdata",res.data.data,this.index);

			})

		},
		//关闭管理操作弹出框
		manageOperationCancel() {
			this.maskLayer = false;
			this.allModelShow = 0;
		},
		//管理操作弹出框 -- 留言正则
		leaveMgChange() {
			//console.log(this.formManageOperation.leaveMsgParaInput);
			if(this.formManageOperation.leaveMsgParaInput.length == 1){
				this.formManageOperation.leaveMsgParaInput=this.formManageOperation.leaveMsgParaInput.replace(/[^1-9]/g,'')
				}else{
				this.formManageOperation.leaveMsgParaInput=this.formManageOperation.leaveMsgParaInput.replace(/\D/g,'')
			}
		},
		//管理操作弹出框 -- 机器人正则
		rbChange() {
			//console.log(this.formManageOperation.rbMsgParaInput);
			if(this.formManageOperation.rbMsgParaInput.length==1){
				this.formManageOperation.rbMsgParaInput=this.formManageOperation.rbMsgParaInput.replace(/[^1-9]/g,'')
				}else{
				this.formManageOperation.rbMsgParaInput=this.formManageOperation.rbMsgParaInput.replace(/\D/g,'')
			}
		},
		// 转化字符
		returnEng(type) {
			for(var i = 0; i < type.length;i++) {
				var jurisdictionType = type[i];
				if(jurisdictionType == "企业订单") {
					type[i] = "company_orders"
				}else if(jurisdictionType == "企业管理") {
					type[i] = "company_manage"
				}else if(jurisdictionType == "企业观察") {
					type[i] = "company_observe"
				}else if(jurisdictionType == "企业网站") {
					type[i] = "company_website"
				}else if(jurisdictionType == "系统设置") {
					type[i] = "system_manage"
				}else if(jurisdictionType == "后台设置") {
					type[i] = "backoffice_manage"
				}else if(jurisdictionType == "企业统计") {
					type[i] = "company_stats"
				}else if(jurisdictionType == "企业趋势") {
					type[i] = "company_trend"
				}
			}
		},
        //留言消息单选按钮change事件
        leaveMsgParaChange(val) {
            if(val == 1 && this.formManageOperation.leaveMsgParaInput == "") {
				this.getManageDatas(1);

            }
		},
		//机器人消息单选按钮change事件
        rbMsgParaChange(val) {
            if(val == 1 && this.formManageOperation.rbMsgParaInput == "") {
				this.getManageDatas(2);
            }
        },
		//获取管理数据
		getManageDatas(num) {
				const ManageParams = {
					server_uid: this.cpMangeDatas.server_uid,
					prefix: this.cpMangeDatas.prefix,
					free_waiter_num: this.formManageOperation.freeWaiterPara,
					free_leave_msg_num: this.formManageOperation.leaveMsgParaInput,
					free_rb_msg_num: this.formManageOperation.rbMsgParaInput
				}

				this.$ajax.post(
					"/api/set_seat_privilege",
					qs.stringify(ManageParams)
				).then(res => {
					if(num == 1) {
						this.formManageOperation.leaveMsgParaInput = res.data.data.default_leave_msg_num;
					}else if (num == 2) {
						this.formManageOperation.rbMsgParaInput = res.data.data.default_rb_msg_num;
					}
					
					//console.log("转化为默认值了222", this.formManageOperation.leaveMsgParaInput)
					
				})
		},
		//修改密码
		//确定
        comfirmPassword(){
		    let that = this;
			let originPassword = localStorage.getItem('password');
			console.log(originPassword)
            if(this.formModifyPassword.originPassword == ''){
                this.modifyPasswordTriggeringCon.originPassword.empty = true;
			}else{
                if(this.formModifyPassword.originPassword != originPassword){
                    this.modifyPasswordTriggeringCon.originPassword.invalid = true;
                }
            }
            if(this.formModifyPassword.newPassword == ''){
                this.modifyPasswordTriggeringCon.newPassword.empty = true;
			}else{
                if(this.formModifyPassword.newPassword.length < 6){
                    this.modifyPasswordTriggeringCon.newPassword.limit = true;
                }
			}

			if(this.formModifyPassword.repeatPassword == ''){
                this.modifyPasswordTriggeringCon.repeatPassword.empty = true;
			}else{
                if(this.formModifyPassword.repeatPassword != this.formModifyPassword.newPassword){
                    this.modifyPasswordTriggeringCon.repeatPassword.identical = true;
                }
			}
            setTimeout(function(){
                that.modifyPasswordTriggeringCon.originPassword.empty = false;
                that.modifyPasswordTriggeringCon.originPassword.invalid = false;
                that.modifyPasswordTriggeringCon.newPassword.empty = false;
                that.modifyPasswordTriggeringCon.newPassword.limit = false;
                that.modifyPasswordTriggeringCon.repeatPassword.empty = false;
                that.modifyPasswordTriggeringCon.repeatPassword.identical = false;
            },2000);
			if(!this.modifyPasswordTriggeringCon.originPassword.empty&&!this.modifyPasswordTriggeringCon.newPassword.limit&&!this.modifyPasswordTriggeringCon.repeatPassword.identical){
			    let modifyPasswordData = {"old_password":this.formModifyPassword.originPassword, "password":this.formModifyPassword.newPassword}
                this.$ajax.post(
                    "/api/modify_password",
                    qs.stringify(modifyPasswordData)
                ).then(res => {
                    console.log(res);
                    if(res.data.error == 'old password error'){
                        this.$refs.formModifyPassword.resetFields();
                    }else{
                        this.$refs.formModifyPassword.resetFields();
                        this.maskLayer = false;
                        this.allModelShow = 0;
                        this.formModifyPassword.originPassword = "";
                        this.formModifyPassword.newPassword = "";
                        this.formModifyPassword.repeatPassword = "";
                    }
                })
            }
		},
		//取消
		addModifyPasswordCancel(){
            this.$refs.formModifyPassword.resetFields();
            this.maskLayer = false;
            this.allModelShow = 0;
            this.formModifyPassword.originPassword = "";
            this.formModifyPassword.newPassword = "";
            this.formModifyPassword.repeatPassword = "";
	 	}
	}

    }
</script>



// WEBPACK FOOTER //
// App.vue?249d25e5